export enum VizTypes {
  Table = 'table',
  Chart = 'chart',
  Python = 'python',
  Text = 'text',
}

// Viz types that can be full height
export enum FullVizTypes {
  Table = VizTypes.Table,
  Text = VizTypes.Text,
}

export const VIZ_SELECTORS = Object.keys(VizTypes)
  .map((k) => 'mode-' + VizTypes[k as keyof typeof VizTypes])
  .join(',');

export const RUNNING_QUERY_STATES = ['new', 'running', 'enqueued', 'pending'];

export const FINISHED_STATES = ['canceled', 'succeeded', 'failed', 'warning'];

export const MAX_SELECTED_FILTER_OPTS = 500;

export const ROW_HEIGHT_ATTR = 'data-row-height';
